import { Box, Breadcrumbs, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Seperator from '../../../assets/images/bc-sep.svg';

const BreadCrumb = () => <Box sx={{ mt: 2 }} />;

BreadCrumb.propTypes = {
    breadItems: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default BreadCrumb;
